/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'snack-bar',
    template: `<div class="snack-bar" (click)="dismissSnackbar()">
                <div class="flex-layout-row flex-layout-gap-5px">
                  <div>
                    <mat-icon>{{ data.icon }}</mat-icon>
                  </div>

                  <div class="body">
                    <div class="title">{{ data.title }}</div>

                    <div>{{ data.message }}</div>
                  </div>
                </div>
              </div>`,
    styles: [
        `
      .snack-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 300px;
      }
      .title {
        font-weight: bold;
      }
      .body {
        padding-left: 15px;
      }
    `,
    ],
    standalone: false
})
export class SnackBarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, public snackBar: MatSnackBar) {}
  public dismissSnackbar(): void {
    this.snackBar.dismiss();
  }
}
